// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var glitch = "_404-module--glitch--1jEPf";
export var glitchSkew = "_404-module--glitch-skew--YKbzn";
export var glitchRed = "_404-module--glitch-red--3tbld";
export var glitchBlue = "_404-module--glitch-blue--6rkRb";
export var notFoundContainer = "_404-module--not-found-container--3fLna";